// MAIN SERVER
const BASE_URL = "https://app.eaugroup.co";

// const BASE_URL = "http://localhost:5001";

// MAJED SERVER
// const BASE_URL = "http://173.214.164.83:5001";

const ENDPOINTS = {
  IMAGE_BASE_URL: `${BASE_URL}/uploads/`,
  PURCHASE_LINK: `${BASE_URL}/chats/auto-login-purchase`,
  REFRESH_TOKEN: `${BASE_URL}/auth/refresh`,
  LOGIN: `${BASE_URL}/auth/login`,
  SIGNUP: `${BASE_URL}/auth/register`,
  RESET_PASSWORD: `${BASE_URL}/auth/resetpassword`,
  SESSION: `${BASE_URL}/auth/session`,
  MEMBERSHIP: `${BASE_URL}/auth/membership`,
  GET_ALL_COMMUNITIES: `${BASE_URL}/community/all`,
  GET_ALL_CHANNELS: `${BASE_URL}/channel/all`,
  GET_ALL_SECTIONS: `${BASE_URL}/section/all`,
  CREATE_SECTION: `${BASE_URL}/section/create`,
  UPDATE_SECTION_BY_ID: (id) => `${BASE_URL}/section/${id}`,
  DELETE_SECTION_BY_ID: (id) => `${BASE_URL}/section/${id}`,
  CREATE_COMMUNITY: `${BASE_URL}/community/create`,
  CREATE_CHANNEL: `${BASE_URL}/channel/create`,
  GET_COMMUNITY_BY_ID: (id) => `${BASE_URL}/community/${id}`,
  REORDER_COMMUNITIES: `${BASE_URL}/community/reorder`,
  REORDER_SECTIONS: `${BASE_URL}/section/reorder`,
  REORDER_CHANNELS: `${BASE_URL}/channel/reorder`,
  // Home Sections - FIXED
  GET_ALL_HOME_SECTIONS: `${BASE_URL}/home/all`,
  GET_HOME_SECTION_BY_ID: (id) => `${BASE_URL}/home/${id}`,
  CREATE_HOME_SECTION: `${BASE_URL}/home/create`,
  UPDATE_HOME_SECTION_BY_ID: (id) => `${BASE_URL}/home/${id}`,
  DELETE_HOME_SECTION_BY_ID: (id) => `${BASE_URL}/home/${id}`,
  REORDER_HOME_SECTIONS: `${BASE_URL}/home/reorder`,

  UPDATE_COMMUNITY_BY_ID: (id) => `${BASE_URL}/community/update/${id}`,
  DELETE_COMMUNITY_BY_ID: (id) => `${BASE_URL}/community/${id}`,
  GET_LINK_PREVIEW: (url) =>
    `${BASE_URL}/chats/link-preview?url=${encodeURIComponent(url)}`,

  // GET_ALL_TRADERS: `${BASE_URL}/wordpress/traders`,
  GET_ALL_TRADERS_SIMPLE: `${BASE_URL}/wordpress/traders/simple`,
  GET_ALL_MEMBERSHIPS: `${BASE_URL}/wordpress/memberships`,
  GET_USER_MEMBERSHIP: `${BASE_URL}/wordpress/user/memberships`,
  GET_CHANNEL_BY_ID: (id) => `${BASE_URL}/channel/${id}`,
  GET_CHANNELS_BY_IDS: `${BASE_URL}/channel/bulk`,
  UPDATE_CHANNEL_BY_ID: (id) => `${BASE_URL}/channel/update/${id}`,
  TOGGLE_CHAT_PERMISSION: (id) =>
    `${BASE_URL}/channel/toggleChatPermission/${id}`,
  TOGGLE_CHAT_NOTIFICATION: `${BASE_URL}/chats/channel/toggleChatNotification`,
  GET_CHAT_NOTIFICATION: `${BASE_URL}/chats/channel/getAllChannelNotificationsPermission`,
  DELETE_CHANNEL_BY_ID: (id) => `${BASE_URL}/channel/${id}`,
  EDIT_MESSAGE: (messageId) => `/chats/messages/${messageId}/edit`,
  DELETE_MESSAGE: (messageId) => `/chats/messages/${messageId}/delete`,

  CREATE_LIVE_SESSION: `${BASE_URL}/livesessions/create`,
  UPDATE_LIVE_SESSION: `${BASE_URL}/livesessions/update`,
  GET_ALL_LIVE_SESSION: `${BASE_URL}/livesessions/all`,
  GET_LIVE_SESSION_BY_COMMUNITY_ID: (id) =>
    `${BASE_URL}/livesessions/community/${id}`,
  DELETE_LIVE_SESSION_BY_ID: (id) => `${BASE_URL}/livesessions/${id}`,
  GET_US30_LIVE_SESSION: `${BASE_URL}/livesessions/us30/next`,
  GET_ZOOM_MEETING_SIGNATURE: `${BASE_URL}/zoom/signature`,
  GET_ALL_USERS: `${BASE_URL}/wordpress/users`,
  GET_ALL_USERS_SIMPLE: `${BASE_URL}/wordpress/users/simple`,
  GET_ALL_USERS_SIMPLE_BY_IDS: `${BASE_URL}/wordpress/users/simpleByIds`,
  SEND_MESSAGE: (channelId) => `${BASE_URL}/chats/channel/${channelId}/message`,
  GET_MESSAGES: (channelId, userId, page = 1, limit = 20) =>
    `${BASE_URL}/chats/channel/${channelId}/messages/${userId}?page=${page}&limit=${limit}`,
  SEARCH_MESSAGES: (channelId, keyword) =>
    `${BASE_URL}/chats/channel/${channelId}/search?keyword=${keyword}`,
  GET_MESSAGES_BY_CONTEXT: (
    channelId,
    userId,
    messageId,
    before = 10,
    after = 10
  ) =>
    `${BASE_URL}/chats/channel/${channelId}/messagesByContext/${userId}?messageId=${messageId}&before=${before}&after=${after}`,
  GET_JOINED_CHANNEL: (userId) => `${BASE_URL}/chats/user/${userId}/channels`,
  JOIN_CHANNEL_CHAT: (channelId) =>
    `${BASE_URL}/chats/channel/${channelId}/join`,
  GET_UNREAD_CHAT_COUNTS: (userId) =>
    `${BASE_URL}/chats/user/${userId}/unreadcounts`,
  MARK_CHANNEL_AS_READ: `${BASE_URL}/chats/user/mark-read`,
  UPLOAD_CHAT_MEDIA: `${BASE_URL}/chats/upload`,
  REACT_TO_A_MESSAGE: (messageId) =>
    `${BASE_URL}/chats/messages/${messageId}/reactions`,
};

export { BASE_URL, ENDPOINTS };
